export default __webpack_public_path__ + "static/media/qr.63e15b78.svg";